(() => {
  const link = document.querySelector('[data-nl-whatsapp]');
  if (!link) return;
  const bar = document.querySelector('sticky-add-to-cart');
  const consentSelector = '#shopify-pc__banner, #shopify-pc__prefs';
  const visible = element => {
    if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
    const style = getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0' && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight;
  };
  const update = () => {
    const blocked = [...document.querySelectorAll(consentSelector)].some(visible);
    link.hidden = blocked;
    const offset = bar?.classList.contains('visible') ? Math.ceil(bar.getBoundingClientRect().height + (parseFloat(getComputedStyle(bar).bottom) || 0)) + 12 : 24;
    link.style.setProperty('--nl-wa-bottom', `${Math.max(24, offset)}px`);
  };
  const observer = new MutationObserver(update);
  if (bar) {
    observer.observe(bar, {attributes:true,attributeFilter:['class','style','hidden']});
    new ResizeObserver(update).observe(bar);
  }
  const observeConsent = () => {
    for (const element of document.querySelectorAll(consentSelector)) observer.observe(element, {attributes:true,attributeFilter:['class','style','hidden','aria-hidden']});
    update();
  };
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches?.(consentSelector) || node.querySelector?.(consentSelector))))) observeConsent();
  }).observe(document.body, {childList:true,subtree:true});
  addEventListener('resize', update, {passive:true});
  addEventListener('load', observeConsent, {once:true});
  observeConsent();
})();
